import { memo } from "react";
import { useSelector, shallowEqual } from "react-redux";
import classNames from "classnames";


import styles from "./SecondBlock.module.scss";

const SecondBlock = ({
  title,
  title_en,
  title_red,
  title_red_en,
  desc,
  desc_en,
  big_image,
  small_image,
  small_image2,
}) => {
  const language = useSelector(
    (state) => state.LangSlice?.language,
    shallowEqual
  );

  const titleHtml = language === "en" ? title_en : title;
  const subtitleHtml = language === "en" ? title_red_en : title_red;
  const listHtml = language === "en" ? desc_en : desc;

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <div className={styles.infoBlock}>
          <div className={styles.titleSubtitleBlock}>
            <div className={styles.titleBlock}>
              {titleHtml && (
                <p dangerouslySetInnerHTML={{ __html: titleHtml }} />
              )}
            </div>
            <div className={styles.subtitleBlock}>
              {subtitleHtml && (
                <p dangerouslySetInnerHTML={{ __html: subtitleHtml }} />
              )}
            </div>
          </div>
          {listHtml && (
            <ul
              className={styles.listItemBlock}
              dangerouslySetInnerHTML={{ __html: listHtml }}
            />
          )}
        </div>
        <div className={styles.imagesBlock}>
          {big_image && (
            <img
              src={big_image}
              alt=""
              width={475}
              height={335}
              loading="lazy"
            />
          )}
          <div
            className={classNames(
              "d-flex justify-content-between align-items-center",
              styles.imgFlexBlock
            )}
          >
            {small_image && (
              <img
                src={small_image}
                alt=""
                width={227}
                height={160}
                loading="lazy"
              />
            )}
            {small_image2 && (
              <img
                src={small_image2}
                alt=""
                width={227}
                height={160}
                loading="lazy"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(SecondBlock);
